module.exports = __webpack_public_path__ + "static/blog-10468505b8550cf4356483774e38644c.jpg";